const baseline = require('../../public/menu-config.json')
const clone = value => JSON.parse(JSON.stringify(value))
function defaultConfig() { return clone(baseline) }
function validateConfig(input, template = baseline) {
  if (!input || input.version !== 1 || !Array.isArray(input.workshops)) throw new Error('配置文件格式不正确或版本不支持')
  const result = clone(template)
  const copy = (target, source, fields) => {
    if (!source) throw new Error('配置缺少项目：' + target.id)
    fields.forEach(field => {
      const value = source[field]
      if (typeof value !== 'string' || value.length > (field === 'hint' || field === 'description' ? 500 : 80) || field === 'name' && !value.trim()) throw new Error(target.id + ' 的文案为空或超出长度限制')
      target[field] = value.replace(/文书/g, '文字')
    })
  }
  result.workshops.forEach(w => {
    const source = input.workshops.find(s => s && s.id === w.id)
    if (!source && w.id === 'keywords') return // Older text exports predate the keyword workshop.
    copy(w, source, ['name', 'description'])
    w.children.forEach(c => {
      const sc = (source.children || []).find(s => s && s.id === c.id)
      if(!sc&&['Date','operators'].includes(c.id))return
      copy(c, sc, ['name', 'description'])
      c.methods.forEach(m => {
        const sm = (sc.methods || []).find(s => s && s.id === m.id)
        if (!sm && ['source.array','source.object','source.date','Array.index','Object.get','Date.getUTCFullYear','operator.multiply'].includes(m.id)) return
        copy(m, sm, ['name', 'group', 'hint'])
      })
    })
  })
  return result
}
module.exports = { defaultConfig, validateConfig }
